// Data skrip telesales — di-generate dari ICS_Compute_Telesales_Script_Book.docx
// Jangan edit manual; ganti file Word lalu re-import kalau ada update.

export const SCRIPT_BOOK = [
  {
    "id": "1",
    "title": "Cloud Infrastructure",
    "target": "IT Manager, CTO, Infrastructure Lead di perusahaan mid-large enterprise",
    "pain": "Biaya on-premise tinggi, sering downtime, tidak ada DR plan, deployment lambat",
    "solution": "Cloud Migration, Backup & DR, Managed Services, Hybrid Cloud, Landing Zone",
    "howto": "Skrip ini adalah kerangka, bukan naskah hafalan. Setiap langkah punya beberapa opsi kalimat — pilih yang paling natural buat kamu. Perhatikan bagian \"Kalau prospect jawab...\" untuk tau harus ke mana arah percakapan selanjutnya.",
    "steps": [
      {
        "title": "PEMBUKAAN",
        "goal": "Disambut dengan baik, pastikan tersambung ke orang yang tepat, dan buka percakapan dengan ringan tanpa langsung jualan.",
        "agentLines": [
          "Halo, selamat [pagi/siang/sore]! Boleh saya bicara dengan Bapak/Ibu [nama]? Saya [nama kamu] dari ICS Compute.",
          "[Setelah tersambung] Halo Pak/Bu [nama]! Saya [nama kamu] dari ICS Compute. Maaf ganggu sebentar ya — nggak lama kok, paling 5 menit. Jadi ICS Compute itu perusahaan teknologi yang bantu perusahaan-perusahaan di Indonesia modernisasi infrastruktur IT mereka — khususnya di area cloud dan managed services. Kita partner resmi AWS."
        ],
        "branches": [
          {
            "cond": "Kalau prospect terdengar buru-buru",
            "guide": "Kasih versi 1 kalimat: \"Singkatnya, kita bantu perusahaan kayak [nama mereka] supaya infrastruktur IT-nya lebih efisien dan nggak makan biaya besar.\" Lalu tanya: \"Boleh saya lanjut 2 menit aja, atau ada waktu yang lebih pas?\""
          },
          {
            "cond": "Kalau prospect tanya \"ICS Compute itu siapa?\"",
            "guide": "Jawab singkat & percaya diri: \"Kita partner cloud & IT resmi AWS, bantu banyak perusahaan migrasi dari server on-premise ke cloud biar lebih hemat dan stabil.\" Lalu langsung transisi ke probing."
          },
          {
            "cond": "Kalau prospect bilang bukan orang yang tepat",
            "guide": "Jangan tutup telepon buru-buru: \"Oh oke Pak/Bu, kira-kira siapa ya yang paling pas saya hubungi untuk urusan infrastruktur IT? Boleh saya minta arahannya?\" — Ini cara dapat referral internal."
          }
        ],
        "examples": {
          "good": "Nada santai, kasih durasi jelas (\"5 menit aja\"), langsung sebut value buat mereka.",
          "bad": "Langsung nyerocos soal fitur produk sebelum kenalan, atau baca skrip kaku kayak robot."
        },
        "tip": "Senyum waktu ngomong — beneran kedengeran dari suara. Dan sebelum call, minimal tau nama perusahaan + industri mereka.",
        "objections": []
      },
      {
        "title": "PROBING KONDISI IT SAAT INI",
        "goal": "Pahami landscape IT mereka sekarang. Dengerin lebih banyak daripada ngomong — catat setiap pain point yang mereka sebut.",
        "agentLines": [
          "Oh iya Pak/Bu, sebelum saya lanjut — boleh saya tanya sebentar soal kondisi infrastruktur IT di perusahaan Bapak/Ibu sekarang? Biar saya bisa ngasih gambaran yang lebih pas.",
          "Untuk server dan infrastruktur IT-nya, sekarang masih full on-premise, atau sudah ada sebagian yang di cloud?",
          "Ada nggak kendala yang lagi sering muncul — misalnya server yang lemot, downtime yang ganggu operasional, atau biaya maintenance yang makin mahal?",
          "Kalau tiba-tiba ada gangguan besar — misalnya listrik mati atau server rusak — ada nggak Disaster Recovery plan yang udah disiapkan?"
        ],
        "branches": [
          {
            "cond": "Kalau jawab \"masih on-premise semua\"",
            "guide": "Ini sinyal bagus. Gali lebih dalam: \"Oh oke, kalau boleh tau apa yang bikin masih bertahan di on-premise? Concern soal biaya migrasi, atau ada pertimbangan lain?\" — Cari tau hambatan mental mereka."
          },
          {
            "cond": "Kalau jawab \"udah pakai cloud\"",
            "guide": "Jangan mundur. Tanya: \"Wah bagus! Pakai cloud provider apa? Dan udah optimal belum dari sisi biaya — atau kadang masih ngerasa cloud bill-nya membengkak?\" — FinOps & optimization jadi angle baru."
          },
          {
            "cond": "Kalau sebut pain point spesifik (downtime/biaya)",
            "guide": "CATAT dan pantulkan balik nanti di Langkah 4. Konfirmasi dulu: \"Kira-kira downtime kayak gitu berapa sering terjadi? Dan dampaknya ke operasional seberapa besar?\""
          },
          {
            "cond": "Kalau jawab \"nggak ada DR plan\"",
            "guide": "Angkat urgensi halus: \"Banyak perusahaan juga gitu sampai akhirnya ada 1 kejadian yang bikin sadar. Untungnya ini yang bisa kita bantu setup.\" — Simpan untuk positioning."
          }
        ],
        "examples": {
          "good": "Tanya terbuka lalu diam, kasih prospect ruang cerita. Lanjutkan dari jawaban mereka.",
          "bad": "Nembak pertanyaan bertubi-tubi tanpa dengerin jawaban, atau langsung motong dengan pitch."
        },
        "tip": "Kalau mereka nyebut \"biaya maintenance tinggi\", \"sering down\", atau \"belum ada DR\" — itu emas. Catat kata-kata persis mereka untuk dipakai lagi nanti.",
        "objections": []
      },
      {
        "title": "PROBING BANT",
        "goal": "Kumpulkan info Budget, Authority, Need, Timeline secara natural — jangan terasa kayak interogasi atau kuesioner.",
        "agentLines": [
          "Kalau boleh tau, di tahun ini ada nggak rencana untuk upgrade infrastruktur atau migrasi ke cloud? Atau masih dalam tahap evaluasi?",
          "Pernah nggak ada diskusi internal soal efisiensi biaya IT — misalnya ngebandingin biaya on-premise vs cloud?",
          "Untuk kebutuhan infrastruktur kayak gini, biasanya sudah ada alokasi anggaran IT tersendiri, atau masih digabung sama budget operasional umum?",
          "Kalau kita bisa tunjukin ada efisiensi signifikan, kira-kira proses approval-nya butuh berapa lama ya? Harus lewat berapa level?",
          "Kalau ada solusi yang menarik, keputusan akhirnya biasanya di tangan siapa ya — Bapak/Ibu sendiri, atau ada direktur IT / CTO yang perlu dilibatkan?",
          "Ada nggak tim procurement atau IT steering committee yang biasanya ikut evaluasi vendor?",
          "Kalau memang ada rencana upgrade atau migrasi, kira-kira targetnya di quarter berapa? Ada deadline project yang ngejar?",
          "Di semester ini ada nggak project IT yang lagi urgent atau masuk prioritas utama?"
        ],
        "branches": [
          {
            "cond": "Kalau jawab \"belum ada rencana\"",
            "guide": "Bukan penolakan. Tanam benih: \"Nggak apa-apa, biasanya justru enak diskusi sebelum ada urgensi. Kalau saya kasih gambaran singkat soal potensi efisiensi, kira-kira menarik nggak?\" BUDGET — Cek Anggaran Tanpa Frontal"
          },
          {
            "cond": "Kalau jawab \"belum ada budget\"",
            "guide": "Reframe ke penghematan: \"Justru ini menarik — banyak klien mulai dari sini. Kita bisa hitung dulu potensi penghematannya, dan sering kali itu yang jadi dasar buat ngajuin budget.\" AUTHORITY — Pastikan Ngobrol dengan Orang Tepat"
          },
          {
            "cond": "Kalau ternyata bukan decision maker",
            "guide": "Jadikan mereka sekutu: \"Oke, kalau gitu boleh nggak saya bantu siapin materi yang bisa Bapak/Ibu sampaikan ke [decision maker]? Atau mungkin kita atur sesi bareng mereka?\" TIMELINE — Cek Urgensi"
          },
          {
            "cond": "Kalau jawab \"belum ada timeline\"",
            "guide": "Buat urgensi lembut: \"Oke. FYI biasanya migrasi cloud yang proper butuh 2-3 bulan persiapan, jadi enak kalau mulai diskusi lebih awal. Kita bisa mulai dari assessment gratis dulu.\""
          }
        ],
        "examples": {
          "good": "",
          "bad": ""
        },
        "tip": "Jangan pernah tanya \"budget-nya berapa?\" secara frontal. Selalu masuk dari angle perencanaan, proses approval, atau potensi penghematan.",
        "objections": []
      },
      {
        "title": "POSITIONING SOLUSI",
        "goal": "Hubungkan pain point yang tadi tergali ke solusi ICS Compute. Buat mereka membayangkan kondisi yang lebih baik.",
        "agentLines": [
          "Nah, ini sebenarnya yang kita sering bantu. Banyak perusahaan yang awalnya full on-premise dan ngerasa biaya maintenance terus naik — kita bantu migrasi ke cloud bertahap, dan biasanya bisa efisiensi biaya infrastruktur 30–40%. Prosesnya kita rancang supaya hampir zero downtime, jadi operasional tetap jalan.",
          "Kita juga bantu setup Backup & Disaster Recovery — jadi kalau ada kejadian nggak terduga, sistem bisa recovery cepat tanpa ganggu bisnis. Ini yang sering jadi \"peace of mind\" buat tim IT dan manajemen. Plus ada Managed Services, jadi tim internal nggak harus handle semua sendiri — ada tim kita yang monitor 24/7."
        ],
        "branches": [
          {
            "cond": "Kalau prospect mulai tertarik",
            "guide": "Jangan over-explain. Ajak lanjut: \"Kedengerannya relevan nggak sama kondisi tadi? Kalau iya, saya rasa worth banget kita diskusi lebih dalam.\""
          },
          {
            "cond": "Kalau prospect skeptis soal migrasi",
            "guide": "Kasih rasa aman: \"Saya ngerti kekhawatirannya — migrasi kedengeran ribet. Tapi justru itu spesialisasi kita, dan kita selalu mulai dari assessment supaya nggak ada surprise. Risiko-nya kita minimalkan.\""
          },
          {
            "cond": "Kalau prospect sebut sudah punya vendor",
            "guide": "Jangan menyerang: \"Bagus! Boleh tau pakai siapa? Saya nggak mau duplikasi — tapi kadang ada area yang belum ter-cover, misalnya DR atau cost optimization. Mungkin di situ kita bisa komplemen.\""
          }
        ],
        "examples": {
          "good": "Sebut angka konkret (\"efisiensi 30-40%\") lalu kaitkan langsung ke pain point yang mereka sebut tadi.",
          "bad": "Nyebutin semua fitur AWS satu-satu tanpa relevansi, bikin prospect kewalahan dan bosan."
        },
        "tip": "",
        "objections": []
      },
      {
        "title": "CLOSING & NEXT STEP",
        "goal": "Akhiri call dengan komitmen next action yang jelas — meeting, kirim info, atau jadwal follow up.",
        "agentLines": [
          "Saya nggak mau ambil banyak waktu. Tapi dari obrolan tadi, saya rasa ada beberapa hal yang worth kita eksplorasi — khususnya soal [pain point yang mereka sebut]. Gimana kalau kita set meeting 30 menit aja — bisa virtual — buat tim kita presentasi solusi yang lebih spesifik untuk kondisi di [nama perusahaan]? Minggu ini atau minggu depan ada waktu yang kosong?",
          "Siap, saya kirimkan overview-nya ke email Bapak/Ibu. Boleh minta alamatnya? Tapi biar lebih pas, boleh saya tau 1-2 hal yang paling ingin Bapak/Ibu lihat di materinya? Dan saya follow up dalam 2-3 hari ya — biar nggak ketimbun di inbox.",
          "Ngerti banget Pak/Bu. Boleh saya reach out lagi minggu depan di waktu yang lebih longgar? Atau kalau lebih enak, saya bisa kirim ringkasan singkat dulu via WhatsApp/email supaya bisa Bapak/Ibu lihat kapan aja.",
          "Oke, nggak masalah! Boleh saya simpan kontak Bapak/Ibu? Biasanya kalau ada kebutuhan mendadak, lebih enak kalau udah kenal duluan. Saya reach out lagi sekitar 1-2 bulan ke depan ya. Terima kasih waktunya!"
        ],
        "branches": [],
        "examples": {
          "good": "",
          "bad": ""
        },
        "tip": "Selalu akhiri dengan next step yang KONKRET dan berbatas waktu. \"Nanti saya hubungi lagi\" tanpa tanggal = lead mati.",
        "objections": [
          {
            "q": "Kirim email/proposal dulu aja",
            "a": "Siap, saya kirimkan overview-nya ke email Bapak/Ibu. Boleh minta alamatnya? Tapi biar lebih pas, boleh saya tau 1-2 hal yang paling ingin Bapak/Ibu lihat di materinya? Dan saya follow up dalam 2-3 hari ya — biar nggak ketimbun di inbox."
          },
          {
            "q": "Nanti aja, lagi sibuk",
            "a": "Ngerti banget Pak/Bu. Boleh saya reach out lagi minggu depan di waktu yang lebih longgar? Atau kalau lebih enak, saya bisa kirim ringkasan singkat dulu via WhatsApp/email supaya bisa Bapak/Ibu lihat kapan aja."
          },
          {
            "q": "Belum ada rencana, belum butuh",
            "a": "Oke, nggak masalah! Boleh saya simpan kontak Bapak/Ibu? Biasanya kalau ada kebutuhan mendadak, lebih enak kalau udah kenal duluan. Saya reach out lagi sekitar 1-2 bulan ke depan ya. Terima kasih waktunya!"
          }
        ]
      }
    ],
    "icon": "☁️",
    "partner": "AWS, Managed Services"
  },
  {
    "id": "2",
    "title": "Data & Analytics",
    "target": "Head of Data, CDO, Analytics Lead, BI Team, Data Engineer",
    "pain": "Data silo, laporan lambat, nggak ada single source of truth, proses manual",
    "solution": "Data Lakehouse, Real-time Pipeline, BI & Reporting, Data Governance (Databricks, MongoDB)",
    "howto": "Prospect di area data biasanya technical dan cepat bosan sama basa-basi. Sebutkan Databricks atau MongoDB lebih awal untuk langsung establish kredibilitas. Fokus ke pain point \"data yang nggak nyambung\".",
    "steps": [
      {
        "title": "PEMBUKAAN",
        "goal": "Buka dengan angle data yang relatable, bukan tech jargon berlebihan. Establish kredibilitas lewat nama partner.",
        "agentLines": [
          "Halo, selamat [pagi/siang/sore]! Boleh saya bicara dengan Bapak/Ibu [nama]? Saya [nama kamu] dari ICS Compute.",
          "[Setelah tersambung] Halo Pak/Bu [nama]! Saya [nama kamu] dari ICS Compute. Maaf ganggu sebentar ya. ICS Compute itu spesialis bantu tim data dan analytics supaya bisa kerja lebih cepat dan efisien. Kita partner resmi Databricks dan MongoDB — dua platform yang lagi banyak dipakai untuk modernisasi data stack."
        ],
        "branches": [
          {
            "cond": "Kalau prospect Head of Data / CDO",
            "guide": "Langsung technical & sejajar: \"Kebetulan banget, karena kita banyak kerja bareng tim data yang lagi transisi ke lakehouse architecture. Boleh saya tau sedikit soal data stack Bapak/Ibu sekarang?\""
          },
          {
            "cond": "Kalau prospect belum familiar Databricks",
            "guide": "Sederhanakan: \"Gampangnya, Databricks itu platform yang nyatuin semua data perusahaan jadi satu tempat, biar gampang diolah dan bikin laporan. Banyak dipakai perusahaan besar sekarang.\""
          }
        ],
        "examples": {
          "good": "Sebut nama platform (Databricks/MongoDB) dengan percaya diri untuk langsung kredibel.",
          "bad": "Terlalu banyak istilah teknis (ETL, schema, pipeline) di kalimat pertama sebelum tau level prospect."
        },
        "tip": "Prospect data seringkali lebih pintar soal teknis daripada kita. Posisikan diri sebagai penghubung ke solusi, bukan sok tau teknis.",
        "objections": []
      },
      {
        "title": "PROBING KONDISI DATA SAAT INI",
        "goal": "Pahami seberapa mature data infrastructure mereka dan di mana pain point-nya.",
        "agentLines": [
          "Boleh saya tanya sebentar soal kondisi data di perusahaan Bapak/Ibu sekarang? Biar saya bisa kasih gambaran yang lebih relevan.",
          "Data-data di perusahaan sekarang disimpan di mana? Masih di database terpisah-pisah, atau sudah ada satu tempat terpusat?",
          "Kalau manajemen minta laporan atau dashboard — biasanya butuh berapa lama untuk disiapkan? Prosesnya masih banyak yang manual?",
          "Ada nggak situasi di mana dua tim punya angka berbeda untuk hal yang sama — karena datanya dari sumber yang beda?"
        ],
        "branches": [
          {
            "cond": "Kalau jawab \"data masih tersebar\"",
            "guide": "Ini pain point utama. Perdalam: \"Kira-kira ada berapa sumber data yang harus digabung manual? Dan siapa yang biasanya kebagian kerjaan ngerapiin itu?\""
          },
          {
            "cond": "Kalau jawab \"laporan lama / manual\"",
            "guide": "Kuantifikasi: \"Kalau boleh tau, berapa jam per minggu tim habiskan cuma buat nyiapin laporan? Itu waktu yang sebenarnya bisa dipakai buat analisis.\""
          },
          {
            "cond": "Kalau jawab \"dua tim beda angka\"",
            "guide": "Ini emas — pantulkan: \"Nah itu klasik banget, dan biasanya bikin meeting jadi ribut soal 'angka siapa yang bener'. Itu yang kita selesaikan dengan single source of truth.\""
          },
          {
            "cond": "Kalau jawab \"sudah cukup rapi\"",
            "guide": "Cari gap lain: \"Bagus! Kalau soal real-time — manajemen bisa lihat data terkini kapan aja, atau masih nunggu laporan mingguan yang kadang udah basi?\""
          }
        ],
        "examples": {
          "good": "Gali dampak bisnis dari data yang berantakan (jam kerja terbuang, keputusan telat).",
          "bad": "Cuma nanya \"pakai tools apa?\" tanpa gali kenapa itu jadi masalah buat mereka."
        },
        "tip": "Pertanyaan \"dua tim beda angka\" hampir selalu kena. Itu pain point universal di perusahaan dengan data silo.",
        "objections": []
      },
      {
        "title": "PROBING BANT",
        "goal": "Gali BANT sambil tetap di konteks data — sambungkan ke kondisi yang mereka ceritakan.",
        "agentLines": [
          "Ada nggak plan tahun ini untuk modernisasi data infrastructure? Misalnya migrasi ke data lakehouse, atau implement BI platform baru?",
          "Tim data sekarang lebih banyak habis waktu di mana — data prep dan cleaning, atau udah bisa fokus ke analisis dan insight?",
          "Untuk kebutuhan data platform kayak gini, biasanya sudah ada budget IT atau digital transformation, atau masih perlu diusulkan?",
          "Kalau ada solusi yang bisa signifikan ngurangin waktu data prep, proses approval-nya di sana gimana?",
          "Untuk keputusan soal platform data, biasanya siapa yang paling berpengaruh — Bapak/Ibu sendiri, atau ada CTO / board yang harus di-align?",
          "Ada nggak tim IT atau architecture yang biasanya ikut evaluate solusi data baru?",
          "Kalau ada rencana upgrade data stack, targetnya kapan mau mulai? Ada project atau deadline bisnis yang ngejar?",
          "Di roadmap digital tahun ini, data modernization masuk di prioritas yang mana?"
        ],
        "branches": [
          {
            "cond": "Kalau jawab \"sibuk di data prep\"",
            "guide": "Positioning ringan: \"Itu yang paling sering kita bantu kurangi. Bayangin kalau 70% waktu prep itu bisa dipangkas — tim bisa fokus ke insight yang beneran ngasih value.\" BUDGET"
          },
          {
            "cond": "Kalau budget belum jelas",
            "guide": "Bangun business case: \"Boleh nanti kita bantu hitung ROI-nya? Biasanya penghematan waktu tim + keputusan yang lebih cepat itu yang jadi justifikasi budget.\" AUTHORITY"
          },
          {
            "cond": "Kalau perlu buy-in tim lain",
            "guide": "Tawarkan bantuan: \"Kalau gitu mungkin enak kalau kita bikin sesi yang libatkan tim architecture juga, biar semua bisa tanya langsung. Saya bisa bantu koordinasikan.\" TIMELINE"
          },
          {
            "cond": "Kalau belum prioritas",
            "guide": "Tanam benih: \"Oke, nggak apa-apa. Boleh saya kirim 1-2 case study perusahaan sejenis yang udah transform data-nya? Biar ada gambaran kalau nanti waktunya tiba.\""
          }
        ],
        "examples": {
          "good": "",
          "bad": ""
        },
        "tip": "Untuk prospect data, ROI dari efisiensi waktu tim adalah argumen budget paling kuat. Selalu kaitkan ke \"waktu yang bisa dihemat\".",
        "objections": []
      },
      {
        "title": "POSITIONING SOLUSI",
        "goal": "Kasih gambaran konkret bagaimana ICS Compute solve problem data mereka.",
        "agentLines": [
          "Dari yang tadi Bapak/Ibu ceritain soal [pain point — misal \"data yang masih silo\"], ini persis yang sering kita selesaikan. Kita bisa bantu build Data Lakehouse — jadi semua data dari berbagai sumber masuk ke satu platform terpusat. Hasilnya, tim nggak perlu ngurusin data dari banyak tempat, dan laporan jauh lebih cepat.",
          "Kita pakai Databricks sebagai platform utama — sekarang jadi standar industri untuk lakehouse dan machine learning. Yang sering jadi game changer itu real-time pipeline — manajemen bisa lihat data up-to-date kapan pun, bukan nunggu laporan mingguan yang udah basi. Plus Data Governance, jadi ada satu single source of truth yang semua tim pegang."
        ],
        "branches": [
          {
            "cond": "Kalau prospect antusias soal lakehouse",
            "guide": "Dalami kebutuhan: \"Menarik! Boleh saya tau use case yang paling pengen Bapak/Ibu selesaikan duluan? Biar demo-nya nanti bisa kita fokusin ke situ.\""
          },
          {
            "cond": "Kalau prospect worry soal migrasi data",
            "guide": "Redakan: \"Wajar. Tapi kita selalu mulai dari assessment dan migrasi bertahap — nggak big bang. Data lama tetap aman, dan kita jalanin paralel dulu sampai yakin.\""
          },
          {
            "cond": "Kalau prospect sudah pakai tool BI lain",
            "guide": "Komplemen: \"Bagus! Databricks justru bisa jadi foundation di belakang tool BI itu — jadi bukan ganti, tapi bikin datanya lebih rapi dan cepat diakses.\""
          }
        ],
        "examples": {
          "good": "Ceritakan transformasi konkret: \"dari nunggu laporan mingguan jadi real-time\".",
          "bad": "Fokus ke spesifikasi teknis platform tanpa nyambungin ke masalah bisnis mereka."
        },
        "tip": "",
        "objections": []
      },
      {
        "title": "CLOSING & NEXT STEP",
        "goal": "Akhiri dengan next step konkret — idealnya sesi teknis atau demo.",
        "agentLines": [
          "Saya nggak mau ambil banyak waktu. Tapi saya rasa kondisi yang tadi diceritain worth banget untuk di-explore lebih dalam. Gimana kalau kita set sesi 30 menit — bisa virtual — supaya tim kita bisa kasih gambaran konkret soal cara modernisasi data stack di [nama perusahaan]? Minggu ini atau depan ada slot kosong?",
          "Siap! Saya kirimkan overview Databricks dan use case yang relevan ke email Bapak/Ibu. Boleh minta alamatnya? Biar makin pas, use case di industri apa yang paling ingin Bapak/Ibu lihat? Saya follow up 2-3 hari.",
          "Ngerti. Justru sesi awal kita biasanya buat ngasih gambaran dulu, jadi tim bisa mulai kebayang tanpa komitmen apa-apa. Boleh saya jadwalin yang santai aja dulu?",
          "Oke, nggak apa-apa! Boleh saya simpan kontaknya dan kirim case study sesekali? Kalau nanti ada project data, kita udah kenal duluan. Terima kasih waktunya!"
        ],
        "branches": [],
        "examples": {
          "good": "",
          "bad": ""
        },
        "tip": "Prospect teknis suka lihat bukti. Tawarkan case study atau demo teknis, bukan cuma \"proposal\".",
        "objections": [
          {
            "q": "Kirim overview dulu",
            "a": "Siap! Saya kirimkan overview Databricks dan use case yang relevan ke email Bapak/Ibu. Boleh minta alamatnya? Biar makin pas, use case di industri apa yang paling ingin Bapak/Ibu lihat? Saya follow up 2-3 hari."
          },
          {
            "q": "Tim belum siap",
            "a": "Ngerti. Justru sesi awal kita biasanya buat ngasih gambaran dulu, jadi tim bisa mulai kebayang tanpa komitmen apa-apa. Boleh saya jadwalin yang santai aja dulu?"
          },
          {
            "q": "Belum ada rencana data",
            "a": "Oke, nggak apa-apa! Boleh saya simpan kontaknya dan kirim case study sesekali? Kalau nanti ada project data, kita udah kenal duluan. Terima kasih waktunya!"
          }
        ]
      }
    ],
    "icon": "📊",
    "partner": "Databricks, MongoDB"
  },
  {
    "id": "3",
    "title": "APM & Monitoring",
    "target": "DevOps Engineer, Engineering Manager, SRE, IT Ops, VP Engineering",
    "pain": "Baru tau ada masalah setelah user komplain, response lambat, tidak ada visibilitas end-to-end",
    "solution": "APM, Infrastructure Monitoring, Log Management, Real User Monitoring, Distributed Tracing (Datadog, Truewatch)",
    "howto": "Prospect DevOps/SRE sangat menghargai efisiensi dan benci downtime. Nama \"Datadog\" biasanya langsung bikin mereka engage. Fokus ke pain \"baru tau masalah dari user komplain\".",
    "steps": [
      {
        "title": "PEMBUKAAN",
        "goal": "Buka dengan angle yang langsung nyentuh dunia mereka — downtime dan incident.",
        "agentLines": [
          "Halo, selamat [pagi/siang/sore]! Boleh saya bicara dengan Bapak/Ibu [nama]? Saya [nama kamu] dari ICS Compute.",
          "[Setelah tersambung] Halo Pak/Bu [nama]! Saya [nama kamu] dari ICS Compute. Maaf ganggu sebentar ya. ICS Compute itu bantu tim engineering dan IT ops supaya punya visibilitas penuh ke semua sistem dan aplikasi mereka — dari infrastruktur sampai pengalaman user langsung. Kita partner Datadog dan Truewatch."
        ],
        "branches": [
          {
            "cond": "Kalau prospect DevOps/SRE",
            "guide": "Bicara bahasa mereka: \"Kebetulan kita banyak bantu tim yang lagi berjuang sama observability — kayak MTTR yang masih tinggi atau alerting yang berisik. Relate nggak sama kondisi tim sekarang?\""
          },
          {
            "cond": "Kalau prospect belum kenal Datadog",
            "guide": "Kasih konteks: \"Datadog itu salah satu platform monitoring paling populer di dunia — dipakai buat mantau aplikasi biar tim tau ada masalah sebelum user komplain.\""
          }
        ],
        "examples": {
          "good": "Sebut \"Datadog\" dan pain point teknis (MTTR, observability) untuk langsung nyambung.",
          "bad": "Terlalu formal dan korporat — prospek DevOps lebih suka obrolan yang to-the-point."
        },
        "tip": "Nama Datadog sering langsung bikin engineer engage. Sebut dari awal, tapi tetap fokus ke masalah mereka, bukan fitur tool.",
        "objections": []
      },
      {
        "title": "PROBING KONDISI MONITORING",
        "goal": "Gali seberapa mature monitoring mereka dan di mana blind spot-nya.",
        "agentLines": [
          "Boleh saya tanya sebentar soal setup monitoring di tim Bapak/Ibu sekarang?",
          "Kalau ada aplikasi yang error atau performa-nya turun — tim biasanya tau dari mana? Dari alert otomatis, atau baru tau setelah ada user/tim lain yang lapor?",
          "Rata-rata berapa lama dari pertama kali masalah muncul sampai tim bisa identify root cause-nya?",
          "Kalau ada incident, debugging-nya gimana — harus cek log dari banyak tempat berbeda, atau udah ada satu tempat terpusat?"
        ],
        "branches": [
          {
            "cond": "Kalau jawab \"baru tau dari user\"",
            "guide": "Pain point utama! Pantulkan: \"Nah itu yang paling bikin tim keteteran — reactive terus. Padahal idealnya tim tau duluan sebelum user kena dampak. Sering kejadian gitu?\""
          },
          {
            "cond": "Kalau jawab \"debug dari banyak tempat\"",
            "guide": "Gali frustrasi: \"Kebayang ribetnya pas lagi incident, harus buka 5 dashboard berbeda sambil dikejar waktu. Itu yang bikin MTTR lama ya?\""
          },
          {
            "cond": "Kalau jawab \"udah pakai monitoring\"",
            "guide": "Cek kelengkapan: \"Bagus! Udah mencakup full stack — dari infra, aplikasi, sampai sisi user? Atau masih ada blind spot di beberapa layer?\""
          },
          {
            "cond": "Kalau jawab \"tim kecil, belum sempat\"",
            "guide": "Empati + solusi: \"Ngerti, tim kecil harus prioritas. Justru monitoring yang bagus itu bikin tim kecil lebih efektif — nggak perlu firefighting terus.\""
          }
        ],
        "examples": {
          "good": "Bangun gambaran pain-nya (firefighting, MTTR tinggi) sebelum tawarkan solusi.",
          "bad": "Langsung tanya \"mau coba Datadog?\" sebelum prospect ngerasa punya masalah."
        },
        "tip": "\"Baru tau dari user\" dan \"debug dari banyak tempat\" adalah dua sinyal terkuat bahwa mereka butuh observability proper.",
        "objections": []
      },
      {
        "title": "PROBING BANT",
        "goal": "Gali BANT dalam konteks engineering dan reliability.",
        "agentLines": [
          "Ada nggak target internal soal uptime atau SLA yang harus dipenuhi? Dan seberapa sering tercapai sekarang?",
          "Tim sekarang pakai tools monitoring apa aja? Semuanya terintegrasi atau masih terpisah-pisah?",
          "Untuk tooling engineering kayak monitoring, biasanya sudah ada budget tersendiri, atau masuk IT budget umum?",
          "Kalau ada downtime yang berdampak ke user — kira-kira cost-nya ke bisnis berapa? Itu biasanya jadi justifikasi kuat buat investasi di monitoring.",
          "Untuk keputusan adopt tools baru, biasanya Bapak/Ibu yang decide, atau perlu approval VP Engineering / CTO?",
          "Ada nggak tim platform engineering yang biasanya jadi evaluator teknis?",
          "Ada nggak deadline tertentu — audit, compliance, atau product launch — yang bikin monitoring jadi prioritas sekarang?",
          "Di roadmap teknis tahun ini, monitoring masuk di prioritas yang mana?"
        ],
        "branches": [
          {
            "cond": "Kalau SLA sering meleset",
            "guide": "Angkat stakes: \"Kalau SLA meleset, biasanya ada dampak ke customer atau bahkan penalti kontrak ya? Itu yang bisa kita bantu jaga dengan monitoring proaktif.\" BUDGET"
          },
          {
            "cond": "Kalau budget terbatas",
            "guide": "Reframe: \"Justru monitoring itu sering bayar sendiri — satu incident besar yang tercegah biasanya udah nutup biaya tool-nya. Kita bisa hitung bareng.\" AUTHORITY"
          },
          {
            "cond": "Kalau perlu approval atasan",
            "guide": "Berdayakan: \"Oke, kalau gitu saya bantu siapin data teknis + business case yang bisa Bapak/Ibu bawa ke atasan. Biasanya itu yang bikin approval lebih cepat.\" TIMELINE"
          },
          {
            "cond": "Kalau belum urgent",
            "guide": "Tawarkan trial: \"Oke. Gimana kalau kita mulai dari POC kecil dulu di satu service? Low risk, dan tim bisa langsung rasain bedanya sebelum commit.\""
          }
        ],
        "examples": {
          "good": "",
          "bad": ""
        },
        "tip": "Untuk monitoring, \"cost of downtime\" adalah angle budget paling kuat. Bantu mereka hitung berapa ruginya 1 jam downtime.",
        "objections": []
      },
      {
        "title": "POSITIONING SOLUSI",
        "goal": "Tunjukkan bagaimana Datadog kasih visibilitas penuh dan pangkas MTTR.",
        "agentLines": [
          "Dari yang tadi diceritain — terutama soal [pain point, misal \"baru tau masalah dari user\"] — ini persis yang Datadog dirancang untuk solve. Dengan Datadog, tim punya visibilitas end-to-end: dari infrastruktur, aplikasi, sampai pengalaman user. Semuanya dalam satu platform. Kalau ada anomali, alert langsung masuk sebelum user kena dampak.",
          "Yang jadi favorit engineer itu Distributed Tracing — kalau ada request lambat atau error, bisa langsung di-trace ke mana masalahnya, tanpa buka 5 dashboard. Log Management-nya juga terpusat, jadi incident response jauh lebih cepat. Banyak tim bilang MTTR turun signifikan setelah adopt Datadog."
        ],
        "branches": [
          {
            "cond": "Kalau prospect tertarik teknis",
            "guide": "Ajak lihat langsung: \"Daripada saya cerita, mending lihat langsung. Kita bisa demo pakai skenario yang mirip stack Bapak/Ibu. Mau?\""
          },
          {
            "cond": "Kalau prospect ragu soal cost",
            "guide": "Kaitkan ke value: \"Saya ngerti Datadog bukan yang termurah. Tapi coba bandingin sama cost 1 major incident + jam tim yang kebuang firefighting. Biasanya worth it.\""
          },
          {
            "cond": "Kalau prospect sudah pakai open source",
            "guide": "Hormati + bandingkan: \"Bagus, banyak tim mulai dari situ. Cuma biasanya maintenance-nya makan waktu tim sendiri. Datadog itu trade-off antara effort maintenance vs biaya lisensi. Kita bisa bantu kalkulasi.\""
          }
        ],
        "examples": {
          "good": "Fokus ke outcome: \"MTTR turun\", \"tau masalah sebelum user komplain\".",
          "bad": "Ngelist semua 300+ integrasi Datadog tanpa relevansi ke stack mereka."
        },
        "tip": "",
        "objections": []
      },
      {
        "title": "CLOSING & NEXT STEP",
        "goal": "Closing ke demo — engineer paling percaya kalau lihat langsung.",
        "agentLines": [
          "Saya nggak mau panjang-panjang. Tapi worth banget kalau kita bisa duduk bareng — bisa virtual — dan tim kita tunjukin demo Datadog yang disesuaikan sama stack Bapak/Ibu. Biasanya lebih jelas lihat langsung daripada dengerin saya cerita. Minggu ini atau depan ada 30 menit kosong?",
          "Siap! Saya kirimkan overview + beberapa case study ya. Boleh minta email Bapak/Ibu? Case study di industri apa yang paling relevan? Saya follow up 2-3 hari.",
          "Ngerti, prioritas. Boleh saya reach out lagi bulan depan? Sambil itu saya kirim 1 artikel tentang cara tim lain pangkas MTTR, siapa tau berguna.",
          "Oke! Kalau nanti ada blind spot atau MTTR mulai jadi masalah, boleh saya jadi opsi? Saya simpan kontak dan reach out sesekali ya. Makasih waktunya!"
        ],
        "branches": [],
        "examples": {
          "good": "",
          "bad": ""
        },
        "tip": "Untuk APM, demo/POC adalah closing terkuat. Engineer percaya bukti, bukan janji. Push ke \"lihat langsung\".",
        "objections": [
          {
            "q": "Kirim info dulu",
            "a": "Siap! Saya kirimkan overview + beberapa case study ya. Boleh minta email Bapak/Ibu? Case study di industri apa yang paling relevan? Saya follow up 2-3 hari."
          },
          {
            "q": "Kita lagi fokus hal lain",
            "a": "Ngerti, prioritas. Boleh saya reach out lagi bulan depan? Sambil itu saya kirim 1 artikel tentang cara tim lain pangkas MTTR, siapa tau berguna."
          },
          {
            "q": "Sudah cukup dengan tools sekarang",
            "a": "Oke! Kalau nanti ada blind spot atau MTTR mulai jadi masalah, boleh saya jadi opsi? Saya simpan kontak dan reach out sesekali ya. Makasih waktunya!"
          }
        ]
      }
    ],
    "icon": "🔍",
    "partner": "Datadog, Truewatch"
  },
  {
    "id": "4",
    "title": "Cybersecurity",
    "target": "CISO, IT Security Lead, Risk & Compliance Officer, IT Manager (dengan fungsi security)",
    "pain": "Ancaman ransomware & endpoint, tidak ada monitoring 24/7, compliance gap, audit yang mendekat",
    "solution": "EDR, Next-Gen Firewall, IAM, SIEM & SOAR, 24/7 SOC (Fortinet, CrowdStrike, Trendmicro)",
    "howto": "Isu keamanan itu sensitif — jangan menakut-nakuti berlebihan, tapi bikin prospect aware. Hook paling kuat: tawaran \"security gap assessment gratis\". Nama Fortinet/CrowdStrike langsung kasih kredibilitas.",
    "steps": [
      {
        "title": "PEMBUKAAN",
        "goal": "Buka dengan angle keamanan yang relevan — bukan menakut-nakuti, tapi bikin aware.",
        "agentLines": [
          "Halo, selamat [pagi/siang/sore]! Boleh saya bicara dengan Bapak/Ibu [nama]? Saya [nama kamu] dari ICS Compute.",
          "[Setelah tersambung] Halo Pak/Bu [nama]! Saya [nama kamu] dari ICS Compute. Maaf ganggu sebentar ya — nggak lama. ICS Compute fokus di area cybersecurity — kita bantu perusahaan-perusahaan di Indonesia untuk proteksi end-to-end, dari endpoint, network, sampai monitoring ancaman 24 jam. Kita partner resmi Fortinet, CrowdStrike, dan Trendmicro."
        ],
        "branches": [
          {
            "cond": "Kalau prospect CISO / Security Lead",
            "guide": "Bicara sejajar: \"Kebetulan kita banyak bantu tim security yang lagi menghadapi tekanan compliance atau kekurangan resource buat monitoring 24/7. Relate nggak sama kondisi Bapak/Ibu?\""
          },
          {
            "cond": "Kalau prospect IT Manager (bukan security khusus)",
            "guide": "Sederhanakan: \"Banyak perusahaan yang security-nya masih dihandle tim IT umum. Kita bantu supaya bebannya lebih ringan tanpa harus rekrut tim security besar.\""
          }
        ],
        "examples": {
          "good": "Sebut partner ternama (Fortinet, CrowdStrike) untuk kredibilitas, nada tenang & profesional.",
          "bad": "Nakut-nakutin dengan cerita ransomware yang berlebihan — bikin prospect defensif."
        },
        "tip": "Jangan jualan lewat ketakutan. Posisikan sebagai partner yang bantu, bukan salesman yang nakut-nakutin.",
        "objections": []
      },
      {
        "title": "PROBING POSTUR KEAMANAN",
        "goal": "Pahami seberapa mature security posture mereka dan di mana celah yang mungkin ada.",
        "agentLines": [
          "Boleh saya tanya sebentar soal kondisi keamanan IT di perusahaan Bapak/Ibu sekarang?",
          "Untuk endpoint — laptop, PC, server — sekarang pakai proteksi apa? Masih antivirus tradisional, atau sudah EDR yang lebih modern?",
          "Kalau ada aktivitas mencurigakan di jaringan — tim tau dari mana? Ada alert otomatis, atau baru ketauan setelah ada insiden?",
          "Kapan terakhir kali ada security audit atau vulnerability assessment di perusahaan Bapak/Ibu?"
        ],
        "branches": [
          {
            "cond": "Kalau jawab \"masih antivirus biasa\"",
            "guide": "Edukasi halus: \"Oke. Antivirus tradisional itu bagus buat ancaman lama, tapi ransomware modern seringkali lolos. EDR beda karena deteksi dari perilaku. Itu salah satu yang bisa kita bantu upgrade.\""
          },
          {
            "cond": "Kalau jawab \"belum pernah audit / lama\"",
            "guide": "Ini opening emas: \"Nah, banyak perusahaan baru sadar ada celah pas udah kejadian. Kita ada security gap assessment yang bisa nunjukin dulu di mana risikonya — dan ini gratis.\""
          },
          {
            "cond": "Kalau jawab \"udah cukup lengkap\"",
            "guide": "Cari layer yang kurang: \"Bagus banget! Kalau soal monitoring 24/7 — ada tim yang mantau ancaman di luar jam kerja, atau lebih ke jam kantor aja?\""
          },
          {
            "cond": "Kalau jawab \"pernah ada insiden\"",
            "guide": "Empati + solusi: \"Wah, pasti bikin waspada ya. Justru dari situ banyak perusahaan mulai serius. Boleh saya tau, setelah itu ada perubahan apa di sistem keamanannya?\""
          }
        ],
        "examples": {
          "good": "Tanya soal audit terakhir — hampir selalu buka celah untuk assessment gratis.",
          "bad": "Langsung asumsi mereka nggak aman dan lecehkan setup mereka sekarang."
        },
        "tip": "Pertanyaan \"kapan terakhir audit?\" adalah pembuka paling efektif. Banyak yang belum pernah, atau sudah lama.",
        "objections": []
      },
      {
        "title": "PROBING BANT",
        "goal": "Gali BANT dalam konteks risk dan compliance.",
        "agentLines": [
          "Ada nggak insiden keamanan belakangan ini — walau kecil — yang bikin tim mulai concern soal postur keamanan?",
          "Ada nggak area keamanan yang Bapak/Ibu sendiri rasa belum ter-cover baik — endpoint, identity, atau cloud security?",
          "Untuk cybersecurity, biasanya sudah ada budget security tersendiri, atau masih bagian dari IT budget umum?",
          "Kalau ada insiden security — kira-kira dampak finansialnya ke perusahaan seperti apa? Itu biasanya jadi dasar justifikasi investasi.",
          "Untuk pengadaan solusi keamanan, biasanya siapa yang paling berpengaruh — Bapak/Ibu, tim IT, atau ada board/komite?",
          "Ada nggak proses RFP atau vendor evaluation yang biasanya dijalankan?",
          "Ada nggak deadline compliance atau audit yang lagi mendekat yang bikin ini prioritas sekarang?",
          "Di roadmap keamanan tahun ini, area mana yang paling urgent di-address duluan?"
        ],
        "branches": [
          {
            "cond": "Kalau sebut area yang lemah",
            "guide": "Fokus ke situ: \"Oke, [area itu] memang sering jadi celah. Kebetulan itu salah satu yang kita kuat. Boleh kita bahas lebih detail nanti di assessment?\" BUDGET"
          },
          {
            "cond": "Kalau budget terbatas",
            "guide": "Reframe ke risiko: \"Ngerti. Tapi coba bandingin sama potensi kerugian 1 serangan ransomware — biaya recovery, downtime, reputasi. Investasi security itu jauh lebih murah dari itu.\" AUTHORITY"
          },
          {
            "cond": "Kalau perlu approval board",
            "guide": "Bantu naik ke atas: \"Kalau perlu presentasi ke board, kita bisa bantu siapin materi risk assessment yang mudah dipahami non-teknis. Itu biasanya bantu percepat keputusan.\" TIMELINE"
          },
          {
            "cond": "Kalau ada audit mendekat",
            "guide": "Manfaatkan urgensi: \"Nah, itu momen yang pas. Kita bisa bantu vulnerability assessment sebelum audit datang, jadi celahnya udah ke-address duluan. Kapan tepatnya audit-nya?\""
          }
        ],
        "examples": {
          "good": "",
          "bad": ""
        },
        "tip": "Compliance deadline (ISO 27001, PCI-DSS) adalah timeline trigger paling kuat. Gali apakah ada audit yang mendekat.",
        "objections": []
      },
      {
        "title": "POSITIONING SOLUSI",
        "goal": "Tunjukkan solusi end-to-end tanpa membebani dengan terlalu banyak produk sekaligus.",
        "agentLines": [
          "Dari yang tadi diceritain — terutama soal [pain point, misal \"belum ada monitoring 24/7\"] — ini yang kita bantu address. Kita punya solusi end-to-end: mulai dari Endpoint Detection & Response dengan CrowdStrike atau Trendmicro — jauh lebih canggih dari antivirus biasa karena deteksi perilaku mencurigakan sebelum jadi insiden — sampai Next-Gen Firewall dari Fortinet untuk proteksi di level network.",
          "Yang sering jadi game changer itu layanan 24/7 SOC kita — ada tim yang mantau ancaman sepanjang waktu, dan kalau ada yang mencurigakan langsung di-respond. Tim internal nggak harus begadang mantau sendiri. Untuk compliance, kita juga bisa bantu vulnerability assessment dan pen testing — jadi sebelum audit datang, celahnya udah ke-address."
        ],
        "branches": [
          {
            "cond": "Kalau prospect tertarik SOC",
            "guide": "Dalami: \"SOC memang jadi favorit karena ngangkat beban tim. Boleh saya tau, sekarang siapa yang handle kalau ada alert keamanan di luar jam kantor?\""
          },
          {
            "cond": "Kalau prospect worry soal kompleksitas",
            "guide": "Redakan: \"Saya ngerti, security bisa kedengeran ribet. Tapi kita bisa mulai bertahap — misalnya endpoint dulu, baru tambah layer lain. Nggak harus sekaligus.\""
          },
          {
            "cond": "Kalau prospect sudah pakai vendor security",
            "guide": "Komplemen: \"Bagus! Boleh tau pakai apa? Kadang ada gap — misalnya endpoint kuat tapi network belum, atau belum ada SOC. Di situ kita bisa lengkapi.\""
          }
        ],
        "examples": {
          "good": "Tawarkan solusi bertahap (\"mulai dari endpoint dulu\") biar nggak overwhelming.",
          "bad": "Jual semua produk (EDR + firewall + SIEM + SOAR + IAM) sekaligus dalam 1 nafas."
        },
        "tip": "",
        "objections": []
      },
      {
        "title": "CLOSING & NEXT STEP",
        "goal": "Closing dengan hook assessment gratis — low barrier, foot-in-the-door.",
        "agentLines": [
          "Saya nggak mau ambil banyak waktu. Tapi dari obrolan tadi, ada beberapa area — khususnya [pain point spesifik] — yang worth kita diskusi lebih dalam. Gimana kalau kita jadwalin 30 menit — bisa virtual — buat tim security kita jelasin lebih detail, dan mungkin kita mulai dengan security gap assessment dulu? Ini gratis dan nggak ada kewajiban apa-apa. Minggu ini atau depan ada waktu?",
          "Siap! Saya kirimkan overview solusi + case study yang relevan ke email Bapak/Ibu. Boleh minta alamatnya? Sambil itu, kalau berkenan, security gap assessment gratisnya tetap bisa kita jadwalin kapan aja. Saya follow up 2-3 hari.",
          "Ngerti. Kita nggak minta ganti — tapi second opinion lewat gap assessment gratis biasanya tetap berharga, siapa tau ada celah yang belum ke-cover. Boleh saya tawarkan itu aja dulu?",
          "Oke, nggak apa-apa! Boleh saya simpan kontak dan reach out menjelang periode audit berikutnya? Sambil itu saya kirim checklist security posture yang bisa dipakai internal. Makasih waktunya!"
        ],
        "branches": [],
        "examples": {
          "good": "",
          "bad": ""
        },
        "tip": "Offer \"security gap assessment gratis\" adalah hook terkuat — low barrier, tapi kasih foot-in-the-door untuk masuk lebih dalam.",
        "objections": [
          {
            "q": "Kirim proposal dulu",
            "a": "Siap! Saya kirimkan overview solusi + case study yang relevan ke email Bapak/Ibu. Boleh minta alamatnya? Sambil itu, kalau berkenan, security gap assessment gratisnya tetap bisa kita jadwalin kapan aja. Saya follow up 2-3 hari."
          },
          {
            "q": "Sudah ada vendor security",
            "a": "Ngerti. Kita nggak minta ganti — tapi second opinion lewat gap assessment gratis biasanya tetap berharga, siapa tau ada celah yang belum ke-cover. Boleh saya tawarkan itu aja dulu?"
          },
          {
            "q": "Belum prioritas sekarang",
            "a": "Oke, nggak apa-apa! Boleh saya simpan kontak dan reach out menjelang periode audit berikutnya? Sambil itu saya kirim checklist security posture yang bisa dipakai internal. Makasih waktunya!"
          }
        ]
      }
    ],
    "icon": "🔒",
    "partner": "Fortinet, CrowdStrike, Trendmicro"
  },
  {
    "id": "5",
    "title": "ERP (Odoo)",
    "target": "Finance Director, CEO/Owner, Operations Manager, IT Manager — SMB & mid-market",
    "pain": "Proses bisnis masih manual/Excel, data operasional tersebar, laporan keuangan lambat, sistem tidak terintegrasi",
    "solution": "Odoo ERP: Finance & Accounting, Inventory, CRM, HR & Payroll, Manufacturing, E-Commerce",
    "howto": "Prospect ERP biasanya bukan orang teknis — mereka business owner atau finance. Bicara soal operasional sehari-hari (Excel, stok, laporan), bukan istilah IT. Hook terkuat: demo langsung.",
    "steps": [
      {
        "title": "PEMBUKAAN",
        "goal": "Buka dengan angle operasional yang relatable — Excel berantakan, proses manual, data nggak nyambung.",
        "agentLines": [
          "Halo, selamat [pagi/siang/sore]! Boleh saya bicara dengan Bapak/Ibu [nama]? Saya [nama kamu] dari ICS Compute.",
          "[Setelah tersambung] Halo Pak/Bu [nama]! Saya [nama kamu] dari ICS Compute. Maaf ganggu sebentar ya — paling 5 menit. ICS Compute salah satunya bantu perusahaan implementasi sistem ERP — khususnya Odoo. Kalau Bapak/Ibu pernah dengar Odoo, itu platform yang nyatuin operasional bisnis — dari finance, inventory, sampai HR — dalam satu sistem."
        ],
        "branches": [
          {
            "cond": "Kalau prospect CEO / Owner",
            "guide": "Bicara bisnis: \"Kebetulan kita banyak bantu bisnis yang lagi berkembang tapi sistemnya masih manual, jadi mulai kerepotan. Kondisi di [nama perusahaan] gimana Pak/Bu?\""
          },
          {
            "cond": "Kalau prospect belum kenal Odoo",
            "guide": "Analogi mudah: \"Gampangnya, Odoo itu kayak SAP — tapi lebih fleksibel dan jauh lebih terjangkau. Cocok buat perusahaan yang mau mulai digitalisasi tanpa budget besar.\""
          }
        ],
        "examples": {
          "good": "Pakai bahasa bisnis sehari-hari (\"operasional\", \"laporan\"), bukan jargon IT.",
          "bad": "Bicara soal \"database\", \"API\", \"modul\" ke prospect yang orang finance/bisnis."
        },
        "tip": "Prospect ERP peduli soal efisiensi bisnis, bukan teknologi. Selalu terjemahkan fitur ke manfaat operasional.",
        "objections": []
      },
      {
        "title": "PROBING KONDISI OPERASIONAL",
        "goal": "Pahami seberapa digital operasional mereka dan di mana proses yang masih manual/terpisah.",
        "agentLines": [
          "Boleh saya tanya sebentar soal kondisi operasional di perusahaan Bapak/Ibu sekarang?",
          "Untuk proses keuangan dan akuntansi — sudah pakai software khusus, atau masih banyak yang manual lewat Excel?",
          "Kalau ada order masuk — dari sales sampai pengiriman — prosesnya gimana? Ada sistem yang track, atau masih lewat WhatsApp dan email?",
          "Kalau manajemen minta laporan — laba rugi, status piutang — butuh berapa lama untuk disiapkan? Harus rekap manual dari banyak tempat?"
        ],
        "branches": [
          {
            "cond": "Kalau jawab \"masih pakai Excel\"",
            "guide": "Gali dampaknya: \"Oke. Excel enak buat mulai, tapi biasanya pas bisnis makin besar jadi ribet — apalagi kalau banyak orang edit file yang sama. Sering nggak ada masalah data yang nggak sinkron?\""
          },
          {
            "cond": "Kalau jawab \"stok sering nggak akurat\"",
            "guide": "Pain point kuat! Pantulkan: \"Nah itu klasik — sales janji ke customer padahal stok kosong, atau sebaliknya. Itu yang bikin operasional pusing ya? Odoo nyatuin itu real-time.\""
          },
          {
            "cond": "Kalau jawab \"laporan lama\"",
            "guide": "Kuantifikasi: \"Kira-kira tim finance habis berapa hari tiap bulan cuma buat nyiapin laporan? Itu waktu yang bisa dipangkas drastis kalau datanya udah terintegrasi.\""
          },
          {
            "cond": "Kalau jawab \"sudah pakai sistem\"",
            "guide": "Cek integrasi: \"Bagus! Sistemnya udah nyambung antar bagian — finance, inventory, sales — atau masih terpisah-pisah dan harus input ulang di tiap sistem?\""
          }
        ],
        "examples": {
          "good": "Gali cerita konkret soal ribetnya proses manual sehari-hari.",
          "bad": "Langsung tanya \"mau pakai Odoo?\" sebelum prospect ngerasa proses mereka bermasalah."
        },
        "tip": "Pertanyaan soal \"stok yang nggak akurat\" dan \"laporan yang lama\" hampir selalu kena di SMB yang belum punya ERP.",
        "objections": []
      },
      {
        "title": "PROBING BANT",
        "goal": "Gali BANT sambil tetap di konteks operasional bisnis.",
        "agentLines": [
          "Ada nggak rencana tahun ini untuk digitalisasi atau upgrade sistem — misalnya implement ERP, atau ganti software yang sekarang?",
          "Ada nggak proses yang Bapak/Ibu rasa paling bikin tim buang waktu — rekap manual, approval lama, atau cek stok yang nggak akurat?",
          "Untuk digitalisasi operasional, biasanya sudah ada anggaran transformasi digital, atau masih perlu diusulkan ke pimpinan?",
          "Salah satu yang bikin Odoo menarik itu modelnya modular — bisa mulai kecil, bayar sesuai modul. Kalau ada solusi yang cocok ke budget, proses approval-nya gimana?",
          "Untuk keputusan implementasi sistem seperti ini, biasanya yang paling berpengaruh siapa — Bapak/Ibu, direktur, atau ada tim IT?",
          "Biasanya kalau ada project digitalisasi, prosesnya langsung decide atau perlu presentasi ke board dulu?",
          "Kalau ada rencana implement ERP, targetnya kapan mau mulai? Ada momen tertentu — awal fiscal year, atau audit yang mendekat?",
          "Di roadmap perusahaan tahun ini, digitalisasi operasional masuk prioritas yang mana?"
        ],
        "branches": [
          {
            "cond": "Kalau sebut proses yang menyita waktu",
            "guide": "Fokus ke situ: \"Nah, [proses itu] persis yang Odoo otomatiskan. Bayangin kalau itu bisa jalan sendiri — tim bisa fokus ke hal yang lebih penting.\" BUDGET"
          },
          {
            "cond": "Kalau khawatir soal biaya",
            "guide": "Tekankan value modular: \"Justru Odoo cocok karena bisa mulai dari 1-2 modul yang paling dibutuhin dulu — misalnya finance & inventory — baru nambah kalau udah kerasa manfaatnya. Nggak harus langsung besar.\" AUTHORITY"
          },
          {
            "cond": "Kalau owner sendiri yang putuskan",
            "guide": "Percepat: \"Wah enak kalau gitu, keputusan bisa lebih cepat. Gimana kalau saya langsung siapin demo yang disesuaikan sama bisnis Bapak/Ibu, biar bisa lihat konkret?\" TIMELINE"
          },
          {
            "cond": "Kalau belum ada timeline",
            "guide": "Tanam benih: \"Oke, nggak apa-apa. Implementasi Odoo biasanya butuh beberapa minggu, jadi enak kalau mulai eksplorasi lebih awal. Boleh saya kasih demo dulu tanpa komitmen?\""
          }
        ],
        "examples": {
          "good": "",
          "bad": ""
        },
        "tip": "Model modular Odoo adalah selling point budget terkuat untuk SMB. Tekankan \"mulai kecil, tambah sesuai kebutuhan\".",
        "objections": []
      },
      {
        "title": "POSITIONING SOLUSI",
        "goal": "Gambarkan bagaimana Odoo nyambungin semua proses yang tadinya terpisah.",
        "agentLines": [
          "Dari yang tadi diceritain — [pain point, misal \"laporan yang masih manual\"] — ini persis yang Odoo solve. Odoo itu modular — semua proses bisnis jalan dalam satu platform. Finance, inventory, sales, purchasing, HR — semua nyambung. Ada order masuk, otomatis kelihatan di inventory. Ada invoice, langsung masuk accounting. Nggak ada lagi input ulang di tempat berbeda.",
          "Yang jadi game changer itu laporan real-time — manajemen bisa lihat profit & loss, cash flow, atau status inventory kapan pun, tanpa nunggu tim finance rekap manual. Untuk sales ada CRM terintegrasi — pipeline ke-track dari lead sampai closed, nggak ada deal yang \"keselip\" di WhatsApp pribadi. Dan yang penting, kita bantu dari analisis kebutuhan, implementasi, sampai training tim."
        ],
        "branches": [
          {
            "cond": "Kalau prospect tertarik",
            "guide": "Arahkan ke demo: \"Daripada saya cerita panjang, paling enak kalau lihat langsung. Kita bisa demo yang disesuaikan sama proses bisnis Bapak/Ibu. Mau saya jadwalin?\""
          },
          {
            "cond": "Kalau prospect worry migrasi data lama",
            "guide": "Redakan: \"Wajar. Tapi kita bantu migrasi data dari sistem/Excel lama, dan implementasinya bertahap. Data lama tetap aman, dan tim didampingi sampai lancar.\""
          },
          {
            "cond": "Kalau prospect bandingkan sama SAP/kompetitor",
            "guide": "Posisikan: \"SAP bagus buat enterprise besar, tapi seringkali overkill dan mahal buat perusahaan yang lagi berkembang. Odoo kasih fitur yang mirip dengan investasi dan kompleksitas yang jauh lebih masuk akal.\""
          }
        ],
        "examples": {
          "good": "Ceritakan alur konkret: \"order masuk → otomatis update stok → langsung ke accounting\".",
          "bad": "Ngelist 40+ modul Odoo tanpa fokus ke yang relevan buat bisnis mereka."
        },
        "tip": "",
        "objections": []
      },
      {
        "title": "CLOSING & NEXT STEP",
        "goal": "Closing ke demo — untuk ERP, lihat langsung jauh lebih kuat dari brosur.",
        "agentLines": [
          "Saya nggak mau ambil banyak waktu. Tapi dari obrolan tadi — terutama soal [pain point] — worth banget untuk kita explore lebih dalam. Gimana kalau kita jadwalin sesi demo Odoo — sekitar 30-45 menit, bisa virtual? Tim kita tunjukin langsung gimana sistemnya bekerja, disesuaikan sama proses bisnis di [nama perusahaan]. Minggu ini atau depan ada slot?",
          "Siap! Saya kirimkan overview Odoo + contoh use case ke email Bapak/Ibu. Boleh minta alamatnya? Tapi Odoo ini jauh lebih kerasa kalau dilihat langsung — kalau berkenan, demo singkatnya tetap bisa kita atur. Saya follow up 2-3 hari.",
          "Ngerti. Nggak harus ganti sekarang. Tapi demo singkat bisa kasih gambaran kalau nanti butuh — dan nggak ada komitmen. Boleh saya jadwalin yang santai aja?",
          "Oke, nggak apa-apa! Boleh saya simpan kontak dan reach out sesekali? Kalau nanti ada rencana digitalisasi atau proses makin ribet, kita udah kenal. Makasih waktunya!"
        ],
        "branches": [],
        "examples": {
          "good": "",
          "bad": ""
        },
        "tip": "Demo adalah closing terkuat untuk ERP. Prospect yang lihat sistem berjalan jauh lebih mudah convert daripada yang cuma baca brosur.",
        "objections": [
          {
            "q": "Kirim info dulu",
            "a": "Siap! Saya kirimkan overview Odoo + contoh use case ke email Bapak/Ibu. Boleh minta alamatnya? Tapi Odoo ini jauh lebih kerasa kalau dilihat langsung — kalau berkenan, demo singkatnya tetap bisa kita atur. Saya follow up 2-3 hari."
          },
          {
            "q": "Masih ragu, sistem sekarang jalan",
            "a": "Ngerti. Nggak harus ganti sekarang. Tapi demo singkat bisa kasih gambaran kalau nanti butuh — dan nggak ada komitmen. Boleh saya jadwalin yang santai aja?"
          },
          {
            "q": "Belum ada rencana",
            "a": "Oke, nggak apa-apa! Boleh saya simpan kontak dan reach out sesekali? Kalau nanti ada rencana digitalisasi atau proses makin ribet, kita udah kenal. Makasih waktunya!"
          }
        ]
      }
    ],
    "icon": "🏢",
    "partner": "Odoo"
  },
  {
    "id": "6",
    "title": "GitLab (DevSecOps)",
    "target": "CTO, VP Engineering, DevOps Lead, Engineering Manager, Head of IT",
    "pain": "Pipeline lambat, tools dev terfragmentasi, security baru dicek menjelang release, visibility SDLC minim",
    "solution": "GitLab CI/CD, Source Code Management, SAST/DAST Security Scanning, Container Registry, Agile Planning",
    "howto": "Prospect GitLab sangat teknis (CTO, VP Eng, DevOps). Sebut \"DevSecOps\" dan \"all-in-one\" lebih awal. Angle terkuat: konsolidasi tools (ganti Jira+GitHub+Jenkins+SonarQube jadi satu). Hook: demo/workshop.",
    "steps": [
      {
        "title": "PEMBUKAAN",
        "goal": "Buka dengan angle engineering — tools terfragmentasi, pipeline lambat, security telat.",
        "agentLines": [
          "Halo, selamat [pagi/siang/sore]! Boleh saya bicara dengan Bapak/Ibu [nama]? Saya [nama kamu] dari ICS Compute.",
          "[Setelah tersambung] Halo Pak/Bu [nama]! Saya [nama kamu] dari ICS Compute. Maaf ganggu sebentar ya — nggak lama. ICS Compute itu partner resmi GitLab di Indonesia. Kita bantu tim engineering supaya bisa ship produk lebih cepat, lebih aman, dan dengan proses lebih terstruktur — dari satu platform yang nyatuin semua tahapan development."
        ],
        "branches": [
          {
            "cond": "Kalau prospect CTO / VP Engineering",
            "guide": "Bicara strategis: \"Kebetulan kita banyak bantu tim yang tools dev-nya masih terpisah-pisah — jadi susah di-govern dan mahal. Kondisi di tim Bapak/Ibu gimana?\""
          },
          {
            "cond": "Kalau prospect DevOps Lead",
            "guide": "Langsung teknis: \"Kita banyak bantu tim yang mau consolidate CI/CD dan security scanning jadi satu. Sekarang pipeline-nya udah terintegrasi, atau masih pakai beberapa tools terpisah?\""
          },
          {
            "cond": "Kalau prospect belum kenal GitLab",
            "guide": "Kasih konteks: \"GitLab itu platform yang nyatuin seluruh siklus development — dari code, testing, security, sampai deploy — dalam satu tempat. Alternatif dari pakai banyak tools terpisah.\""
          }
        ],
        "examples": {
          "good": "Sebut \"DevSecOps\" & \"all-in-one platform\" untuk langsung nyambung dengan CTO/DevOps.",
          "bad": "Terlalu formal & korporat — tim engineering lebih suka obrolan to-the-point dan technical."
        },
        "tip": "Sebut \"partner resmi GitLab\" untuk kredibilitas. Sesuaikan entry point: CTO = strategis, DevOps = teknis.",
        "objections": []
      },
      {
        "title": "PROBING KONDISI DEVELOPMENT",
        "goal": "Pahami seberapa mature DevOps mereka dan di mana bottleneck-nya.",
        "agentLines": [
          "Boleh saya tanya sebentar soal setup development dan DevOps di tim Bapak/Ibu sekarang?",
          "Untuk source code management, pakai apa — GitHub, Bitbucket, atau lainnya? Sudah terintegrasi sama CI/CD pipeline?",
          "Untuk keamanan kode — ada nggak security scanning yang jalan otomatis di pipeline? Atau masih manual dan baru dicek menjelang release?",
          "Tim dev pakai berapa tools berbeda untuk manage seluruh siklus development — dari planning sampai deployment? Semuanya nyambung atau banyak yang manual?"
        ],
        "branches": [
          {
            "cond": "Kalau jawab \"pakai banyak tools terpisah\"",
            "guide": "Pain point utama! Gali: \"Kira-kira ada berapa tools yang tim juggle sekarang? Dan seberapa sering ada friction pas pindah-pindah antar tools itu?\""
          },
          {
            "cond": "Kalau jawab \"security dicek manual/telat\"",
            "guide": "Angkat risiko: \"Nah, itu yang bahaya — kalau security baru dicek di akhir, vulnerability sering lolos ke production. GitLab jalanin scanning otomatis dari awal. Sering ada temuan telat gitu?\""
          },
          {
            "cond": "Kalau jawab \"udah pakai GitHub\"",
            "guide": "Jangan serang: \"Bagus, GitHub solid. Kalau soal CI/CD dan security scanning — udah terintegrasi di situ, atau masih pakai tool terpisah kayak Jenkins/SonarQube?\""
          },
          {
            "cond": "Kalau jawab \"deploy lambat\"",
            "guide": "Perdalam: \"Kira-kira bottleneck-nya di mana — proses approval, testing manual, atau setup pipeline yang ribet? Itu yang biasanya kita bantu streamline.\""
          }
        ],
        "examples": {
          "good": "Gali jumlah tools & friction-nya sebelum tawarkan konsolidasi.",
          "bad": "Langsung bilang \"GitHub kalah dari GitLab\" — bikin prospect defensif."
        },
        "tip": "\"Tools terfragmentasi\" dan \"security dicek telat\" adalah dua entry point terkuat untuk GitLab.",
        "objections": []
      },
      {
        "title": "PROBING BANT",
        "goal": "Gali BANT dalam konteks engineering dan DevOps.",
        "agentLines": [
          "Ada nggak target/OKR di tim engineering tahun ini soal developer productivity, deployment frequency, atau time-to-market?",
          "Pernah ada diskusi soal konsolidasi tools dev — ngurangin jumlah tools biar lebih efisien dan mudah di-manage?",
          "Untuk tooling engineering, biasanya sudah ada budget tersendiri di tim, atau masuk IT budget umum?",
          "Kalau ada solusi yang bisa replace beberapa tools sekaligus jadi satu platform — cost justification-nya di sana gimana?",
          "Untuk keputusan adopt/ganti tools engineering, inisiatifnya dari tim dev sendiri, atau perlu approval CTO / IT Management?",
          "Ada nggak tim security atau compliance yang perlu di-align, khususnya soal DevSecOps atau audit trail?",
          "Ada nggak deadline tertentu — audit keamanan, product launch, atau roadmap engineering — yang bikin ini prioritas?",
          "Di roadmap teknis tahun ini, developer tooling atau DevSecOps masuk prioritas yang mana?"
        ],
        "branches": [
          {
            "cond": "Kalau ada target productivity",
            "guide": "Kaitkan: \"Nah, GitLab langsung nyentuh itu — dengan pipeline terintegrasi, deployment frequency biasanya naik dan lead time turun. Kita bisa tunjukin metrics-nya di demo.\" BUDGET"
          },
          {
            "cond": "Kalau budget jadi concern",
            "guide": "Argumen konsolidasi: \"Justru ini menarik — kalau sekarang bayar Jira + GitHub + Jenkins + SonarQube terpisah, total lisensinya sering lebih mahal dari GitLab Ultimate yang all-in-one. Kita bisa bantu hitung.\" AUTHORITY"
          },
          {
            "cond": "Kalau perlu buy-in security team",
            "guide": "Jadikan kekuatan: \"Bagus kalau security dilibatkan — justru GitLab kuat di situ. Mungkin enak kalau demo-nya kita libatkan tim security juga, biar mereka lihat scanning-nya langsung.\" TIMELINE"
          },
          {
            "cond": "Kalau belum urgent",
            "guide": "Tawarkan POC: \"Oke. Gimana kalau kita mulai dari trial atau POC di satu project dulu? Low risk, dan tim bisa langsung rasain bedanya sebelum commit besar.\""
          }
        ],
        "examples": {
          "good": "",
          "bad": ""
        },
        "tip": "Argumen konsolidasi biaya (ganti banyak tools jadi satu) adalah angle budget terkuat untuk GitLab.",
        "objections": []
      },
      {
        "title": "POSITIONING SOLUSI",
        "goal": "Tunjukkan bagaimana GitLab replace banyak tools & bikin SDLC lebih cepat dan aman.",
        "agentLines": [
          "Dari yang tadi diceritain — terutama soal [pain point, misal \"pipeline lambat\"] — ini persis yang GitLab solve. GitLab itu DevSecOps platform all-in-one. Dari source code management, CI/CD, sampai security scanning — semua dalam satu tool, satu login, satu dashboard. Nggak perlu bolak-balik antara GitHub, Jenkins, SonarQube, dan Jira yang terpisah.",
          "Yang bikin GitLab kuat itu built-in security scanning-nya — SAST, DAST, dependency & container scanning — semua jalan otomatis di pipeline. Jadi security bukan bottleneck di akhir, tapi ke-check dari awal (\"shift left security\"). Tim catch vulnerability lebih awal, sebelum production. Plus CI/CD-nya fleksibel, bisa deploy ke cloud manapun, dan ada Agile Planning terintegrasi jadi nggak perlu Jira terpisah."
        ],
        "branches": [
          {
            "cond": "Kalau prospect tertarik konsolidasi",
            "guide": "Kuantifikasi: \"Boleh nanti kita bantu petakan tools yang sekarang dipakai vs yang bisa digantikan GitLab? Biasanya kelihatan penghematan biaya + berkurangnya kompleksitas.\""
          },
          {
            "cond": "Kalau prospect loyal ke GitHub",
            "guide": "Hormati: \"GitHub bagus, nggak salah. Tapi kalau CI/CD dan security masih pakai tool terpisah, GitLab bisa nyatuin itu. Kita bisa bandingin objektif — mana yang lebih efisien buat tim.\""
          },
          {
            "cond": "Kalau prospect fokus ke security",
            "guide": "Highlight DevSecOps: \"Kalau security jadi prioritas, GitLab pas banget — scanning built-in di setiap commit, plus compliance dashboard. Tim security bisa lihat postur keamanan seluruh codebase real-time.\""
          }
        ],
        "examples": {
          "good": "Fokus ke \"satu platform, ganti banyak tools\" + shift-left security.",
          "bad": "Ngelist semua fitur GitLab tanpa nyambung ke pain point tim mereka."
        },
        "tip": "",
        "objections": []
      },
      {
        "title": "CLOSING & NEXT STEP",
        "goal": "Closing ke demo/workshop — engineer paling percaya kalau lihat langsung.",
        "agentLines": [
          "Saya nggak mau ambil banyak waktu. Tapi dari obrolan tadi — terutama soal [pain point] — worth banget untuk kita eksplorasi lebih dalam. Gimana kalau kita set sesi demo atau mini-workshop GitLab — sekitar 45 menit, bisa virtual atau onsite — buat tim engineering lihat langsung gimana platform-nya bekerja? Kita sesuaikan sama stack yang tim pakai sekarang. Minggu ini atau depan ada slot?",
          "Siap! Saya kirimkan overview GitLab + comparison vs tools yang biasa dipakai ke email Bapak/Ibu. Boleh minta alamatnya? Tapi GitLab paling kerasa kalau lihat pipeline-nya jalan langsung — demo singkatnya tetap bisa kita atur. Saya follow up 2-3 hari.",
          "Ngerti banget. Justru demo-nya bisa kita atur singkat & fleksibel, kapan tim ada waktu. Boleh saya reach out lagi minggu depan buat cari slot yang pas?",
          "Oke! Kalau nanti kompleksitas tools mulai jadi beban atau ada kebutuhan security scanning, boleh saya jadi opsi? Saya simpan kontak dan kirim comparison-nya buat referensi. Makasih waktunya!"
        ],
        "branches": [],
        "examples": {
          "good": "",
          "bad": ""
        },
        "tip": "Demo/workshop adalah hook terkuat untuk GitLab. Kalau bisa, minta CTO atau VP Engineering ikut sesi demo.",
        "objections": [
          {
            "q": "Kirim info dulu",
            "a": "Siap! Saya kirimkan overview GitLab + comparison vs tools yang biasa dipakai ke email Bapak/Ibu. Boleh minta alamatnya? Tapi GitLab paling kerasa kalau lihat pipeline-nya jalan langsung — demo singkatnya tetap bisa kita atur. Saya follow up 2-3 hari."
          },
          {
            "q": "Tim lagi fokus development",
            "a": "Ngerti banget. Justru demo-nya bisa kita atur singkat & fleksibel, kapan tim ada waktu. Boleh saya reach out lagi minggu depan buat cari slot yang pas?"
          },
          {
            "q": "Sudah nyaman dengan tools sekarang",
            "a": "Oke! Kalau nanti kompleksitas tools mulai jadi beban atau ada kebutuhan security scanning, boleh saya jadi opsi? Saya simpan kontak dan kirim comparison-nya buat referensi. Makasih waktunya!"
          }
        ]
      }
    ],
    "icon": "🦊",
    "partner": "GitLab (ICS partner resmi)"
  }
]
